import http from "@/utils/http";

// 查询登录地址（发消息用）
export const queryLoginPath = () => http.get('wx/loginpath.htm', {}, {cache: true})
// 发消息
export const sendMessage = data => http.post('sendMessage', data)